import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xhn8v8jpht: FaireBrandEntity = {
  token: "b_xhn8v8jpht",
  type: "brand",
  name: "Rebecca Illustrated",
  avatarUrl:
    "https://cdn.faire.com/fastly/88ee82aa1b18f4127391721a078408f281f51fd9c59da390c50920a31a46d2dc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cd2638218c0930c9a6a6337a81550d637ad10f939750c851468cd9310a147aed.png",
  logoUrl:
    "https://cdn.faire.com/fastly/88ee82aa1b18f4127391721a078408f281f51fd9c59da390c50920a31a46d2dc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cd2638218c0930c9a6a6337a81550d637ad10f939750c851468cd9310a147aed.png",
  location: "Charleston, SC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "Rebecca Illustrated is a lifestyle brand founded by artist Rebecca. After her husband suffered a life-altering accident and could no longer work, Rebecca turned to painting as both a creative outlet and a way to support her family. What began at her kitchen table in Charleston during a season of uncertainty became something far greater, a business built on hope, creativity, and connection.\n\nSince 2008, Rebecca has been creating hand-drawn watercolor artwork inspired by the places, experiences, and moments that stay with us long after they've passed. From coastal towns and favorite vacation destinations to beloved local landmarks, her illustrations are designed to evoke the feeling of being somewhere you love.\n\nMore than artwork, each piece tells a story. It reminds us of where we've been, who we've shared those moments with, and why certain places will always feel like home.\n\nToday, Rebecca Illustrated is carried by retailers across the country, offering artwork, stationery, puzzles, apparel, mahjong accessories, gifts, and keepsakes that help people celebrate the places and memories they treasure most.\n\nRebecca's work has been featured at the Martha Stewart Weddings Shows in New York City and Chicago and recognized by Cosmopolitan, Anthropologie, and New York Magazine.\n\nRebecca Illustrated operates from 507½ King Street and The Mills House Hotel by Hilton in Charleston, South Carolina.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:18.299Z",
    importedBy: "entity-db-cli",
  },
};
